import React from "react";
import { TextField } from "@mui/material";

export default function CustomInput({ onFileSelect, accept }) {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    onFileSelect?.(file);
  };

  return (
    <TextField
      type="file"
      variant="outlined"
      fullWidth
      inputProps={{ accept: accept }}
      onChange={handleFileChange}
    />
  );
}